import {getColor, SIZE_CHOICES, MDCButtonComponent} from './button.component';


class NormalButtonComponent extends MDCButtonComponent {
  constructor($element) {
    'ngInject';
    super($element);

    this.size = SIZE_CHOICES.NORMAL;

    this.isDisabled = false;
    this.isWarning = false;
    this.isFaded = false;
  }

  getButtonColor() {
    return getColor(this.light, this.highlight, this.isWarning, this.isFaded);
  }
}

const config = MDCButtonComponent.componentConfig(NormalButtonComponent);

const mod = angular.module('common.materialComponents.normalButton', [
])

.component('normalButton', config);

export default mod.name;
